import React, {useState} from 'react'
import {Hero, Event} from '../components'
import useTrip from '../custom/useTrip';
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

function ContactScreen() {
    const [form, setForm] = useState('msg');
    const {viaggi} = useTrip();
    useTitle("Contattaci");
    useDescription("Vuoi sapere di piú su Ceppo o sui nostri viaggi organizzati? Scrivici compilando questo Form!");

    const changeForm = (setform)=>{
        setForm(setform);
    }
    return (
        <div>
            <Hero overlay>
                <hr/>
                    <div>
                        <h3>Contattaci!</h3>
                    </div>
                <hr/>
            </Hero>
            <div className="section-text">
                <h5 style={{textAlign:"center"}}>Vuoi partecipare ad un'escursione organizzata oppure chiedere informazioni?</h5>
                <p style={{textAlign:"center", marginBottom:"10px"}}>Scrivici al seguente form!</p>
                <div className="contact-container">
                    
                    <div className="contact-form">
                        <div className="form-group">
                            <label htmlFor="msg">Seleziona il tipo di messaggio da inviarci:</label>
                        </div>
                        <select id="select-form" className="form-group selector" onChange={()=>changeForm(document.getElementById("select-form").value)}>
                            <option value="msg">Informazioni</option>
                            {
                                viaggi && viaggi.map(viaggio=><option key={viaggio.id} value={viaggio.id}>{viaggio.title}{viaggio.prenote.isFull && " -- PIENO --"}</option>)
                            }
                        </select>
                        <div className="container">
                            {
                                form !== "msg" && viaggi.filter(viaggio=>viaggio.id===form).map(viaggio=><Event key={viaggio.id} {...viaggio} button/>)
                            }
                        </div>
                        <form>
                            <div className="form-group">
                                <label htmlFor="nome">Nome</label>
                                <input type="text" id="nome" name="name" className="input" placeholder='Andrea' required/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="cognome">Cognome</label>
                                <input type="text" id="Cognome" name="Cognome" className="input" placeholder='Pignotti' required/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email" className="input" placeholder='andrea@esempio.com' required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"/>
                            </div>
                            {
                                form !== "msg" && <BetterForm viaggio={viaggi.filter(viaggio=>viaggio.id===form)[0]}/>
                            }
                            <div className="form-group">
                                <label htmlFor="msg">Messaggio</label>
                                <textarea type="tel" id="msg" name="msg" className="input" placeholder='Scrivi un messaggio!' required/>
                            </div>
                            <div className="container">
                                {
                                    viaggi.filter(viaggio=>viaggio.id===form)[0] &&
                                    viaggi.filter(viaggio=>viaggio.id===form)[0].prenote.isFull ?
                                    <button className="card-button red" disabled>PRENOTAZIONI BLOCCATE</button>:
                                    <button type="submit" className="card-button">Invia Messaggio</button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


const BetterForm = ({viaggio})=>{

    return(
        <>
            <div className="form-group">
                <label htmlFor="cellulare">Telefono</label>
                <input
                  type="cel"
                  id="cellulare"
                  name="cellulare"
                  className="input"
                  placeholder="555 555-5555"
                  required
                />
            </div>
            <div className="form-group">
                <label htmlFor="partecipanti">Numero partecipanti
                {
                    !viaggio.prenote.isFull && ` (${viaggio.prenote.max-viaggio.prenote.used} posti disponibili)`
                }
                </label>
                <input
                  type="number"
                  id="partecipanti"
                  name="partecipanti"
                  className="input"
                  placeholder={viaggio.prenote.isFull ? 0 : 1}
                  min={viaggio.prenote.isFull ? 0 : 1 }
                  max={viaggio.prenote.max-viaggio.prenote.used}
                  required
                />
            </div>
        </>
    )
}




export default ContactScreen
